import { Ref } from 'react'
import { Locale } from './Locale'

export default function PaginationController({
  currentPage,
  setCurrentPage,
  maxPage,
}: {
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  maxPage: number
}) {
  if (maxPage == 0) {
    return <Locale en="No Result" zh_cn="没有结果" zh_hk="沒有結果" />
  }
  return (
    <>
      {currentPage > 1 && (
        <>
          <button onClick={() => setCurrentPage(1)}>1</button>
          {currentPage > 2 && <button className="ellipsis">...</button>}
        </>
      )}
      {currentPage > 2 && (
        <button onClick={() => setCurrentPage(prev => prev - 1)}>
          {currentPage - 1}
        </button>
      )}
      <button className="current">{currentPage}</button>
      {currentPage < maxPage - 1 && (
        <button onClick={() => setCurrentPage(prev => prev + 1)}>
          {currentPage + 1}
        </button>
      )}
      {currentPage < maxPage - 2 && <button className="ellipsis">...</button>}
      {currentPage < maxPage && (
        <>
          {currentPage !== maxPage && (
            <button onClick={() => setCurrentPage(maxPage)}>{maxPage}</button>
          )}
        </>
      )}
    </>
  )
}
